import React, { useEffect, useRef } from 'react';
import { GOOGLE_ADS_CONFIG, AD_SIZES, AD_POSITIONS } from '../config/googleAds';

interface GoogleAdProps {
  position: keyof typeof AD_POSITIONS;
  size?: keyof typeof AD_SIZES;
  className?: string;
}

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export const GoogleAd: React.FC<GoogleAdProps> = ({ position, size = 'RESPONSIVE', className = '' }) => {
  const adRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!GOOGLE_ADS_CONFIG.ENABLED) return;

    try {
      // Initialize adsbygoogle
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (err) {
      console.error('Error loading Google Ad:', err);
    }
  }, []);

  if (!GOOGLE_ADS_CONFIG.ENABLED) {
    return null;
  }

  const getAdStyle = () => {
    if (size === 'RESPONSIVE') {
      return {
        display: 'block',
        width: 'auto',
        height: 'auto',
      };
    }

    const dimensions = AD_SIZES[size];
    if (!dimensions || dimensions === 'auto') {
      return {
        display: 'block',
        width: 'auto',
        height: 'auto',
      };
    }

    const [width, height] = dimensions.split('x').map(Number);
    return {
      display: 'block',
      width: `${width}px`,
      height: `${height}px`,
    };
  };

  const getAdSlotId = () => {
    switch (position) {
      case 'LEFT_SIDEBAR':
        return GOOGLE_ADS_CONFIG.AD_SLOTS.LEFT_SIDEBAR;
      case 'RIGHT_SIDEBAR':
        return GOOGLE_ADS_CONFIG.AD_SLOTS.RIGHT_SIDEBAR;
      default:
        return GOOGLE_ADS_CONFIG.AD_SLOTS.LEFT_SIDEBAR; // fallback to left sidebar slot
    }
  };

  return (
    <div className={`google-ad ${position} ${className}`} ref={adRef}>
      <ins
        className="adsbygoogle"
        style={getAdStyle()}
        data-ad-client={GOOGLE_ADS_CONFIG.ADS_CLIENT_ID}
        data-ad-slot={getAdSlotId()}
        data-ad-format={size === 'RESPONSIVE' ? 'auto' : 'rectangle'}
        data-full-width-responsive={size === 'RESPONSIVE'}
      />
    </div>
  );
}; 